export default {"src":"/_next/static/media/users.e681856c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};